import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getRequest, patchRequest } from 'apis/ApiInstence';
import { toast } from 'react-toastify';

const BACKEND = process.env.REACT_APP_BACKEND;

const UpdateGiftProduct = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '', selling_price: '', original_price: '', shipping_charge: '',
    description: '', benefit_description: '', giftbox_type: '', box_material: '',
    box_size: '', box_weight: '', stock_quantity: '', rating: '', status: 'active',
  });
  const [firstImage, setFirstImage] = useState(null);
  const [moreImages, setMoreImages] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchOne = async () => {
      try {
        const res = await getRequest(`gift-products/${id}`);
        const item = res?.data || {};
        setFormData((prev) => ({ ...prev, ...item }));
      } catch (err) {
        console.error('Failed to fetch gift product:', err);
        toast.error('Failed to load gift product details.');
      }
    };
    fetchOne();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFirstImageChange = (e) => {
    setFirstImage(e.target.files[0] || null);
  };

  const handleMoreImagesChange = (e) => {
    setMoreImages(Array.from(e.target.files || []));
  };

  const parseImages = (val) => {
    if (!val) return [];
    try { return JSON.parse(val); } catch { return []; }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);

    const payload = new FormData();
    const fields = ['name','selling_price','original_price','shipping_charge','description',
      'benefit_description','giftbox_type','box_material','box_size','box_weight','stock_quantity','rating','status'];
    fields.forEach((f) => payload.append(f, formData[f] || ''));
    if (firstImage) {
      payload.append('images', firstImage);
    }
    for (let i = 0; i < moreImages.length; i++) {
      payload.append('images', moreImages[i]);
    }

    try {
      await patchRequest(`gift-products/${id}`, payload, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      toast.success('Gift product updated successfully!');
      navigate('/gift-products');
    } catch (error) {
      toast.error(error?.response?.data?.message || error?.message || 'Update failed.');
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid mt-5">
      <div className="mainheadig mx-4">
        <h4 className="text-white font-weight-bold">Update Gift Product</h4>
      </div>
      <form onSubmit={handleSubmit} encType="multipart/form-data">
        <div className="row mx-4 mt-5">
          <div className="col-sm-4 mt-2">
            <label className="admin-label" htmlFor="name">Name</label>
            <input id="name" type="text" name="name" className="form-control" value={formData.name || ''} onChange={handleChange} required />
          </div>
          <div className="col-sm-4 mt-2">
            <label className="admin-label" htmlFor="selling_price">Selling Price</label>
            <input id="selling_price" type="number" step="0.01" name="selling_price" className="form-control" value={formData.selling_price || ''} onChange={handleChange} />
          </div>
          <div className="col-sm-4 mt-2">
            <label className="admin-label" htmlFor="original_price">Original Price</label>
            <input id="original_price" type="number" step="0.01" name="original_price" className="form-control" value={formData.original_price || ''} onChange={handleChange} />
          </div>
          <div className="col-sm-4 mt-2">
            <label className="admin-label" htmlFor="shipping_charge">Shipping Charge</label>
            <input id="shipping_charge" type="number" step="0.01" name="shipping_charge" className="form-control" value={formData.shipping_charge || ''} onChange={handleChange} />
          </div>
          <div className="col-sm-4 mt-2">
            <label className="admin-label" htmlFor="stock_quantity">Stock Quantity</label>
            <input id="stock_quantity" type="number" step="1" name="stock_quantity" className="form-control" value={formData.stock_quantity ?? ''} onChange={handleChange} />
          </div>
          <div className="col-sm-4 mt-2">
            <label className="admin-label" htmlFor="giftbox_type">Giftbox Type</label>
            <input id="giftbox_type" type="text" name="giftbox_type" className="form-control" value={formData.giftbox_type || ''} onChange={handleChange} />
          </div>
          <div className="col-sm-4 mt-2">
            <label className="admin-label" htmlFor="box_material">Box Material</label>
            <input id="box_material" type="text" name="box_material" className="form-control" value={formData.box_material || ''} onChange={handleChange} />
          </div>
          <div className="col-sm-4 mt-2">
            <label className="admin-label" htmlFor="box_size">Box Size</label>
            <input id="box_size" type="text" name="box_size" className="form-control" value={formData.box_size || ''} onChange={handleChange} />
          </div>
          <div className="col-sm-4 mt-2">
            <label className="admin-label" htmlFor="box_weight">Box Weight</label>
            <input id="box_weight" type="number" step="0.01" name="box_weight" className="form-control" value={formData.box_weight || ''} onChange={handleChange} />
          </div>
          <div className="col-sm-4 mt-2">
            <label className="admin-label" htmlFor="rating">Rating</label>
            <input id="rating" type="number" step="0.1" min="0" max="5" name="rating" className="form-control" value={formData.rating || ''} onChange={handleChange} />
          </div>
          <div className="col-sm-4 mt-2">
            <label className="admin-label" htmlFor="status">Status</label>
            <select id="status" name="status" className="form-control" value={formData.status || 'active'} onChange={handleChange}>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </div>
          <div className="col-sm-12 mt-2">
            <label className="admin-label" htmlFor="description">Description</label>
            <textarea id="description" rows={4} name="description" className="form-control" value={formData.description || ''} onChange={handleChange} />
          </div>
          <div className="col-sm-12 mt-2">
            <label className="admin-label" htmlFor="benefit_description">Benefit Description</label>
            <textarea id="benefit_description" rows={3} name="benefit_description" className="form-control" value={formData.benefit_description || ''} onChange={handleChange} />
          </div>
          <div className="col-sm-3 mt-2">
            <label className="admin-label" htmlFor="giftUpdateFirstImage">Choose First Image</label>
            <input id="giftUpdateFirstImage" type="file" accept="image/*" className="form-control" onChange={handleFirstImageChange} />
            {firstImage && (
              <div className="mt-2">
                <img src={URL.createObjectURL(firstImage)} alt="First" className="border" width={80} height={80} style={{ objectFit: 'cover', borderRadius: 4 }} />
                <span className="ml-2 text-success font-weight-bold">First Image</span>
              </div>
            )}
          </div>
          <div className="col-sm-3 mt-2">
            <label className="admin-label" htmlFor="giftUpdateMoreImages">Choose More Images</label>
            <input id="giftUpdateMoreImages" type="file" accept="image/*" multiple className="form-control" onChange={handleMoreImagesChange} />
            {moreImages.length > 0 && (
              <div className="d-flex flex-wrap mt-2" style={{ gap: 5 }}>
                {moreImages.map((file, i) => (
                  <img key={i} src={URL.createObjectURL(file)} alt={`New ${i}`} width={60} height={60} style={{ objectFit: 'cover', borderRadius: 4 }} />
                ))}
              </div>
            )}
          </div>
          <div className="col-sm-6 mt-2">
            <div className="font-weight-bold mb-1">Current Images</div>
            {(() => {
              const imgs = parseImages(formData.images);
              return imgs.length > 0 ? (
                <div className="d-flex flex-wrap" style={{ gap: 5 }}>
                  {imgs.map((img, i) => (
                    <div key={i} className="text-center">
                      <img src={`${BACKEND}uploads/${img}`} alt={`Current ${i}`} width={60} height={60} style={{ objectFit: 'cover', borderRadius: 4 }} />
                      {i === 0 && <div className="text-success font-weight-bold" style={{ fontSize: 11 }}>First</div>}
                    </div>
                  ))}
                </div>
              ) : <p className="text-muted">No images</p>;
            })()}
          </div>
        </div>
        <div className="my-3 text-right mx-4">
          <button type="submit" className="btn addbtn" disabled={loading}>
            {loading ? 'Updating...' : 'Update Gift Product'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default UpdateGiftProduct;
